import React, { useEffect, useState } from 'react';
import { Field } from '@cordata/buffet';
import { useFormikContext } from 'formik';
import { all, spread } from 'axios';
import { find } from 'lodash';

import {
  referenceAdminInstance as RefAdmin,
  authorizedInstanceNoBase as FullUrl,
} from '~/utils';

const SecurityGroups = () => {
  const [permissions, setPermissions] = useState([]);
  const [loading, setLoading] = useState(true);
  const [
    securityPermissionsFromRelationship,
    setSecurityPermissionsFromRelationship,
  ] = useState([]);
  const { values, setFieldValue } = useFormikContext();

  useEffect(() => {
    RefAdmin
      .get('ReferenceSecurityPermission', {
        params: {
          page: 1,
          'page-size': 10000,
          sort: 'securityPermissionLabel,defaultSortOrder',
        },
      })
      .then(({ data: { data } }) => {
        setPermissions(data);
      });

    if (values.relationships) {
      FullUrl
        .get(values.relationships.referenceSecurityGroupSecurityPermissions.related)
        .then(({ data: { data } }) =>
          all([
            data,
            ...data.map(d =>
              FullUrl
                .get(d.relationships.securityPermission.related)),
          ]))
        .then(spread((
          mappingTable,
          ...secPerms
        ) => {
          const spfr = mappingTable.map(t => ({
            ...t,
            attributes: {
              ...t.attributes,
              securityPermission: find(secPerms.map(p => p.data.data), ['id', t.attributes.securityPermissionUid]),
            },
          }));

          setSecurityPermissionsFromRelationship(spfr);
          setFieldValue('spfr', spfr);
        }));
    } else {
      setFieldValue('permissions', []);
      setFieldValue('spfr', []);
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    if (permissions.length && securityPermissionsFromRelationship.length) {
      setFieldValue('permissions', permissions.filter(p =>
        securityPermissionsFromRelationship
          .filter(s => s.attributes.isActive)
          .map(spfr =>
            spfr.attributes.securityPermissionUid).includes(p.id)));

      setLoading(false);
    }
  }, [permissions, securityPermissionsFromRelationship]);

  const validate = (value) => {
    let error;

    if (value && value.length === 0) {
      error = 'must have at least 1 item';
    }

    return error;
  };

  return (
    <Field
      name="permissions"
      type="checkbox-group"
      validate={validate}
      options={permissions}
      getOptionValue={o => o.id}
      getOptionLabel={o => (
        <span>
          <strong>{o.attributes.securityPermissionLabel}</strong>
          {' - '}
          {o.attributes.securityPermissionDescription}
        </span>
      )}
      loading={loading}
      required
    />
  );
};

export default SecurityGroups;
